import { getV2 } from './client';
import fallbackProjects from '../data/projects';

export async function fetchProjects() {
  try {
    const res = await getV2('/products.php');
    if (res?.status === 'success' && Array.isArray(res?.data?.items)) {
      // Keep checked-in artwork and newer catalog entries when the API lags a deploy.
      return fallbackProjects.map((item) => {
        const remote = res.data.items.find((project) => project.id === item.id);
        return { ...remote, ...item };
      });
    }
  } catch (error) {
    // fallback keeps the page stable even if v2 endpoint is unavailable
  }

  return fallbackProjects;
}
